<template>
  <router-view>
  </router-view>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState("assembly", ["assemblySheets"])
  },
  created() {
    if (this.assemblySheets.length == 0) {
      this.getAssemblySheets();
    }
  },
  methods: {
    ...mapActions("projects", ["getProjects"]),
    ...mapActions("assembly", ["getAssemblySheets", "deleteAssemblySheet"])
  }
}
</script>